import { createRoot } from "@wordpress/element";
import App from "./components/App";

document.querySelectorAll(".wp-block-weather-warnings-map").forEach((el) => {
	const root = el.querySelector(".weather-warnings-map__app");
	if (root) {
		createRoot(root).render(<App />);
	}
});
